import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/toaster";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Planos from "./pages/Planos";
import Disciplinas from "./pages/Disciplinas";
import Edital from "./pages/Edital";
import Planejamento from "./pages/Planejamento";
import Revisoes from "./pages/Revisoes";
import Historico from "./pages/Historico";
import Estatisticas from "./pages/Estatisticas";
import Simulados from "./pages/Simulados";
import Convide from "./pages/Convide";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/planos" element={<Planos />} />
        <Route path="/disciplinas" element={<Disciplinas />} />
        <Route path="/edital" element={<Edital />} />
        <Route path="/planejamento" element={<Planejamento />} />
        <Route path="/revisoes" element={<Revisoes />} />
        <Route path="/historico" element={<Historico />} />
        <Route path="/estatisticas" element={<Estatisticas />} />
        <Route path="/simulados" element={<Simulados />} />
        <Route path="/convide" element={<Convide />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
